import moment from "moment";

const shortcutOnClick = (numDays) => {
  return (picker) => {
    const start = moment().subtract(numDays, "days");
    const end = moment().subtract(1, "day");
    picker.$emit("pick", [start.toDate(), end.toDate()]);
  };
};

export const dashboardPeriodOptions = ["Day", "Week", "Month", "Year"].map(
  (period) => ({ label: period, value: period.toLowerCase() })
);

export const datePickerOptions = {
  shortcuts: [
    { text: "Last week", onClick: shortcutOnClick(7) },
    { text: "Last month", onClick: shortcutOnClick(30) },
    { text: "Last 3 months", onClick: shortcutOnClick(90) },
  ],
};

export const defaultReportItem = {
  name: "",
  kpi: null,
  chart_type: "line",
  filters: [],
  breakdown: [],
  border_color: "",
};

export const defaultFilterItem = {
  property: "",
  operator: "eq",
  value: "",
};

export const defaultBreakdownItem = {
  ...defaultFilterItem,
  border_color: "",
  label: "",
};
